import '../css/style.styl'
import 'reset-css'
import 'regenerator-runtime/runtime'

import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { NodePass } from 'three/examples/jsm/nodes/postprocessing/NodePass.js';
import * as Nodes from 'three/examples/jsm/nodes/Nodes.js';

import ViewerGUI from './gui'

import DebugInfo from './debugInfo'
import {loadGLTF, loadFBX, replaceMaterial, loadCubeMap, loadTexture} from './resourceLoader'

import Params from './parameter'
import { Vector3 } from 'three'

window.onload = ()=>{
  const app = new App();
  app.init();
}



class App{
  constructor(){
   
    this.debugInfo = new DebugInfo();
  }

  async init(){ 
    // setup renderer
    this.renderer = new THREE.WebGLRenderer( { antialias: true } );
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = false;
    this.renderer.shadowMap.needsUpdate = true; // create shadow map at once (needsUpdate will turn false automatically on next frame)
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.info.autoReset = false;
     
    
    document.body.appendChild( this.renderer.domElement );


    // create camera
    this.camera = new THREE.PerspectiveCamera( 45, window.innerWidth/window.innerHeight, 0.25, 10000);
    const camPos = Params.initCameraPos;
    this.camera.position.set(camPos.x, camPos.y, camPos.z);

    // create scene
    this.scene = new THREE.Scene();

    // render pass (posteffect etc.)
    this.setupRenderPass();
    
    // set up scene objects (wait loading assets before starting rendering)
    await this.initScene();

    // clock
    this.clock = new THREE.Clock();

    // Viewer GUI
    const viewerGUI = new ViewerGUI(this.camera);

    // execute render loop
    this.render();
    window.addEventListener( 'resize', this.onWindowResize.bind(this), false );
  } // end of init()

  onWindowResize(){
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.composer.setSize( window.innerWidth, window.innerHeight );
  }

  

  async initScene(){
    // scene params
    const shadowBias = -0.0005;

    // put directional light
    this.dirLight = new THREE.DirectionalLight( 0xffffff, 1);
    this.dirLight.position.set( -400, 300, 400 );
    this.dirLight.castShadow = Params.bEnableDirLightShadow;
    this.dirLight.shadow.camera.near = 1;
    this.dirLight.shadow.camera.far = 1000;
    this.dirLight.shadow.camera.right = 100;
    this.dirLight.shadow.camera.left = -100;
    this.dirLight.shadow.camera.top	= 100;
    this.dirLight.shadow.camera.bottom = -100;
    this.dirLight.shadow.mapSize.width = 1024;
    this.dirLight.shadow.mapSize.height = 1024;
    this.dirLight.shadow.bias = shadowBias;
    this.dirLight.visible = Params.bEnableDirLight;
    this.dirLight.intensity = Params.dirLightIntensity;
    this.scene.add(this.dirLight);

    this.subDirLight = new THREE.DirectionalLight( 0xffffff, 1);
    this.subDirLight.position.set( -400, 300, 400 );
    this.subDirLight.intensity = Params.subDirLightIntensity;
    this.scene.add(this.subDirLight);

    this.ambientLight = new THREE.AmbientLight( 0xffffff );
    this.ambientLight.intensity = Params.ambientLightIntensity;
    this.ambientLight.visible = Params.bEnableAmbientLight;
    this.scene.add(this.ambientLight);

    this.debugInfo.checkTime("start DL env map");

    // load environment map
    this.debugInfo.checkTime("start DL background dome");
    this.loadBackground();
    this.debugInfo.checkTime("env DL background dome");
    

    this.debugInfo.checkTime("start DL CUBE MAP");
    const cubeMap = await loadCubeMap(Params.cubemapPath, '.png');
    this.cubeMap = cubeMap;
    this.debugInfo.checkTime("end DL CUBE MAP");

    this.debugInfo.checkTime("start DL REF CUBE MAP");
    const refCubeMap = await loadCubeMap('/assets/20200827_refCubemap/', '.png');
    this.refCubeMap = refCubeMap;
    this.debugInfo.checkTime("end DL REF CUBE MAP");
    
    // control
    this.controls = new OrbitControls( this.camera, this.renderer.domElement );
    this.controls.minDistance = 2;
    this.controls.maxDistance = 10000;
    const camTarget = Params.initCameraTarget;
    this.controls.target.set( camTarget.x, camTarget.y, camTarget.z );


    this.debugInfo.checkTime("start load model");
    await this.loadModel(Params.modelPath);
    this.debugInfo.checkTime("end load model");

    // helper for debug
    // this.scene.add( new THREE.CameraHelper( this.dirLight.shadow.camera ) );
  }

  setupRenderPass(){
    // composer
    this.composer = new EffectComposer(this.renderer);

    this.composer.addPass(new RenderPass(this.scene, this.camera));
  }

  async loadBackground(){
    const obj = await loadGLTF('/assets/background.glb');
    const model = obj.scene;
    
    model.traverse((child)=>{ 
      if(child.isMesh){
        // 床は建物と同じマテリアルを設定し、シャドウを落とす
        if(child.name == 'Ground'){
          replaceMaterial(child, Params.defaultMaterial);
          child.receiveShadow = true;
        }
        else
          replaceMaterial(child, 'MeshBasicMaterial');
        
        // samplerをNearlestに設定(デフォルトがLinear)
        // if(child.material.map){
        //   child.material.map.minFilter = THREE.NearestFilter;
        //   child.material.map.magFilter = THREE.NearestFilter;
        // }
      }
    });
     // add to scene
     this.scene.add(model);  
  }
  
  async loadModel(modelPath){
    const isGltf = modelPath.match(/\.(gltf|glb)$/) != null
    const isFbx = modelPath.match(/\.(fbx)$/) != null

    let model = null;
    if(isGltf){
      const obj = await loadGLTF(modelPath)
      model = obj.scene;
    }else if(isFbx){
      model = await loadFBX(modelPath);
    }else{
      return;
    }
    model.traverse((child)=>{ 
      if(child.isMesh){
        child.material.emissive = 0;
        child.material.envMapIntensity = Params.envIntensity;

        if(Params.bEnableDirLightShadow){
          if(child.material.opacity < 1){
            child.castShadow = false;
            child.receiveShadow = false;
          }else{
            child.castShadow = true;
            child.receiveShadow = true;
          }
        }
        if(Params.modelName == 'sample1' &&
          (child.name == 'geom_00148_g') ) {
          child.material.envMap = this.refCubeMap;
        }else{
          child.material.envMap = this.cubeMap;
        }

        if(Params.modelName == 'sample1' &&
          (child.name == 'geom_00156_g') ) {
          // child.material.map.minFilter = THREE.LinearMipMapNearestFilter;
          // child.material.map.minFilter = THREE.NearestMipMapNearestFilter;
          // child.material.map.minFilter = THREE.NearestFilter;
          // child.material.map.minFilter = THREE.NearestMipMapLinearFilter;
          // child.material.map.minFilter = THREE.LinearFilter;
          child.material.map.minFilter = THREE.LinearMipMapLinearFilter;
          child.material.map.generateMipmaps = true;
          child.material.map.needsUpdate = true;
        }
        

        if(Params.defaultMaterial != 'MeshStandardMaterial')
          replaceMaterial(child, Params.defaultMaterial);
        
        // samplerをNearlestに設定(デフォルトがLinear)
        // if(child.material.map){
        //   child.material.map.minFilter = THREE.NearestFilter;
        //   child.material.map.magFilter = THREE.NearestFilter;
        // }
        
        
      }
    });

    // add to scene
    this.scene.add(model);  
  }

  render(){
    const loop = ()=>{
      requestAnimationFrame( loop );

      const delta = this.clock.getDelta();
      this.controls.update();
      this.debugInfo.update(this.scene, this.renderer);
      this.composer.render();
    }
    loop();
  }
}

